import React, { useState, useEffect } from 'react'
import AppointmentService from '../../../../../services/api/appointment.service'
import AppointmentForm from '../appointment-form/AppointmentForm'
import moment from 'moment'
import APIResponse from '../../../../templates/components/APIResponse';
import * as moment1 from "moment-timezone";
import TimeZoneEnum from '../../../../../common/enum/time-zone.enum';
import Utilities from '../../../../../services/commonservice/utilities';
import ModalBox from '../../../../templates/components/ModalBox';

const AddAppointmentForm = (props) => {
    const [apiResponse, setApiResponse] = useState()
    const [inputData, setInputData] = useState(props.initialData || {})
    const [disabled, setDisabled] = useState(false)
    const [ignoreLocationWorkingHours, setIgnoreLocationWorkingHours] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [submitData, setSubmitData] = useState({})
    const [ignoreBookedEquipment, setIgnoreBookedEquipment] = useState(false);
    const onSuccess = (message) => {
        // Reset flags only on success
        setIgnoreLocationWorkingHours(false);
        setIgnoreBookedEquipment(false);
        setInputData(clearTemplate)
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    useEffect(() => {
        if(ignoreLocationWorkingHours){
            setConfirmModal(false)
            submitHandler(submitData);
        }
    }, [ignoreLocationWorkingHours])

    useEffect(() => {
        if(ignoreBookedEquipment){
            setConfirmModal(false)
            submitHandler(submitData);
        }
    }, [ignoreBookedEquipment])
    const onError = (error, showConfirmationModal) => {
        if (showConfirmationModal) {
            // Check if API returns array or string
            const message =
                Array.isArray(error) && error.length > 0
                    ? error[0]
                    : typeof error === "string"
                        ? error
                        : "This appointment encountered an error."; // fallback

            setErrorMessage(message);
            setConfirmModal(true);
        }
    }
    const clearTemplate = {
        "aptTotalCount": "",
        "checkEligibility": "",
        "day": "",
        "doctorId": "",
        "duration": "",
        "email": "",
        "equipmentId": "",
        "fromDate": "",
        "memo": "",
        "patientId": "",
        "patientInsuranceId": "",
        "phone": "",
        // "practiceAppointmentStatusCodeId": "",
        // "practiceLocationId": "",
        "practiceLocationRoomId": "",
        "practicePatientTypeId": "",
        "practiceServiceTypeId": "",
        "reasonForVisit": "",
        "repeatOn": "",
        "timeZone": 58,
        "toDate":"",
        "patientPhone":"",
        "clear":true,
        "childAppointments" : []
    }
  
    const submitHandler = (data) => {
        setSubmitData(data)
        setDisabled(true);

        let array={
        "aptTotalCount": data.aptTotalCount,
        "checkEligibility": data.checkEligibility,
        "day": moment(data.fromDate).day(),
        "doctorId": data.doctorId && data.doctorId!==""? data.doctorId : undefined ,
        "duration": data.duration,
        "email": data.email,
        "equipmentId": data.equipmentId && data.equipmentId!==""? data.equipmentId : undefined,
        "fromDate": Utilities.convertUISchedulingDateToDBFormat(data.fromDate),
        "memo": data.memo,
        "patientId": data.patientId,
        "patientInsuranceId": data.patientInsuranceId,
        "phone": data.patientPhone,
        "practiceAppointmentStatusCodeId": data.practiceAppointmentStatusCodeId,
        "practiceLocationId": data.practiceLocationId,
        "practiceLocationRoomId": data.practiceLocationRoomId && data.practiceLocationRoomId!=="" ? data.practiceLocationRoomId : undefined,
        "practicePatientTypeId": data.practicePatientTypeId,
        "practiceServiceTypeId": data.practiceServiceTypeId,
        "reasonForVisit": data.memo,
        "repeatOn": data.repeatOn,
        "timeZone":  58, // TimeZoneEnum[moment1.tz.guess()] != undefined ? TimeZoneEnum[moment1.tz.guess()] : TimeZoneEnum["Default"],
        "toDate": Utilities.convertUISchedulingDateToDBFormat(data.toDate),
        "providerRequested" : Boolean(data.providerRequested),
        "appointmentLocationType": data.appointmentLocationType || "Office"
    }
        if (data.childAppointments && data.childAppointments.length > 0) {
            //reset sequence in correct order
            array.childAppointments = data.childAppointments.map((item, index) => {
                item.sequence = index + 1
                item.doctorId = item.doctorId && item.doctorId !== "" ? item.doctorId : undefined
                item.equipmentId = item.equipmentId && item.equipmentId !== "" ? item.equipmentId : undefined
                item.practiceLocationRoomId = item.practiceLocationRoomId && item.practiceLocationRoomId !== "" ? item.practiceLocationRoomId : undefined
                //delete item.sequenceId
                return item
            })
        } else {
            array.childAppointments = [];
        }
        if (ignoreLocationWorkingHours) {
            array.ignoreLocationWorkingHours = ignoreLocationWorkingHours
        }
        if(ignoreBookedEquipment){
            array.ignoreBookedEquipment = ignoreBookedEquipment
        }
        return AppointmentService.addAppointment(array)
        .then((res) => {               
            setApiResponse(res);
            setDisabled(false);
        })
        .catch((err) => {               
            setApiResponse(err);
            // Don't reset flags on error - they may need to persist for retry
            setDisabled(false);
        });
    }
    return (
        <>
            <AppointmentForm disabled={disabled} submitHandler={submitHandler} onClose={props.onClose} isModal={props.isModal} initialData={inputData} submitLabel="Submit" additionalButton={props.additionalButton} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} onError={onError} toastOnSuccess={true}/>
            <ModalBox open={confirmModal} onClose={() => setConfirmModal(false)} title="Confirm">
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col">
                        <p>{errorMessage} Override and create appointment?</p>
                    </div>
                    <div className="col-auto">
                        <button
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.preventDefault();
                                const lowerMessage = errorMessage.toLowerCase();
                                // Check for equipment booking conflict
                                const isEquipmentError = lowerMessage.includes("equipment") && lowerMessage.includes("booked");
                                // Check for location working hours error
                                const isLocationHoursError = lowerMessage.includes("working") && lowerMessage.includes("hours");
                                
                                if (isEquipmentError) {
                                    setIgnoreBookedEquipment(true);
                                } else if (isLocationHoursError) {
                                    setIgnoreLocationWorkingHours(true);
                                } else {
                                    // Default to location working hours for unknown errors
                                    setIgnoreLocationWorkingHours(true);
                                }
                            }}
                        >
                            OK
                        </button>
                        <button
                            className="btn btn-secondary ms-3"
                            onClick={(e) => {
                                e.preventDefault();
                                setConfirmModal(false);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </ModalBox>
        </>
    )
}

export default AddAppointmentForm